export default {
  common: {
    confirm: '확인',
    cancel: '취소',
    save: '저장',
    delete: '삭제',
    edit: '편집',
    add: '추가',
    search: '검색',
    loading: '로딩 중...',
    success: '작업 성공',
    error: '작업 실패',
    networkError: '네트워크 오류'
  },
  nav: {
    home: '홈',
    card: '명함',
    contacts: '연락처',
    chat: '채팅',
    profile: '프로필'
  },
  profile: {
    title: '프로필',
    personalInfo: '개인 정보',
    editProfile: '프로필 편집',
    myCards: '내 명함',
    myContacts: '내 연락처',
    settings: '설정',
    logout: '로그아웃',
    totalVisitors: '총 방문자 수',
    friendCount: '친구 수',
    todayVisitors: '오늘의 방문자',
    todayIncrement: '오늘의 증가'
  },
  settings: {
    accountSecurity: '계정 보안',
    notificationSettings: '알림 설정',
    languageSettings: '언어 설정',
    logout: '로그아웃',
    accountSecurityDesc: '비밀번호 변경, 휴대폰 바인딩 등',
    notificationSettingsDesc: '메시지 알림 설정 관리',
    languageSettingsDesc: '앱 언어 선택',
    logoutDesc: '현재 계정에서 안전하게 로그아웃'
  },
  language: {
    title: '언어 설정',
    selectLanguage: '언어 선택',
    zhCN: '중국어(간체)',
    enUS: '영어',
    jaJP: '일본어',
    koKR: '한국어',
    ruRU: '러시아어'
  },
  contact: {
    sameLevel: '동일 레벨 연락처',
    higherLevel: '상위 레벨 연락처',
    goldMember: '골드 회원',
    platinumMember: '플래티넘 회원',
    diamondMember: '다이아몬드 회원',
    unlock: '잠금 해제',
    contact: '연락',
    unlockContact: '연락처 잠금 해제',
    upgradeForContacts: '더 많은 연락처를 해제하려면 멤버십 업그레이드'
  },
  storage: {
    basicPlan: '기본 플랜',
    professionalPlan: '프로페셔널 플랜',
    enterprisePlan: '엔터프라이즈 플랜',
    month: '월',
    features: {
      basic: ['50GB 저장 공간', '기본 보안', '파일 공유'],
      professional: ['200GB 저장 공간', '고급 보안 암호화', '팀 협업', '우선 고객 지원'],
      enterprise: ['1TB 저장 공간', '엔터프라이즈 수준 보안', '무제한 협업', '전용 고객 지원']
    },
    buyStorage: '저장 공간 구매',
    buyPlan: '플랜 구매',
    uploadFile: '파일 업로드',
    viewFiles: '파일 보기',
    downloadAll: '일괄 다운로드',
    documents: '문서',
    images: '이미지',
    videos: '비디오',
    others: '기타'
  },
  menu: {
    myCards: '내 명함',
    myCardsDesc: '디지털 명함 관리',
    memberCenter: '멤버 센터',
    memberCenterDesc: '더 많은 혜택을 받기 위해 멤버십 업그레이드',
    myFavorites: '내 즐겨찾기',
    myFavoritesDesc: '저장된 콘텐츠 보기',
    myRelations: '내 관계',
    myRelationsDesc: '소셜 관계 관리',
    chat: '채팅 & 소셜',
    chatDesc: '친구와 채팅 및 상호 작용',
    contacts: '연락처',
    contactsDesc: '연락처 관리',
    privacy: '개인 정보 설정',
    privacyDesc: '개인 정보 권한 관리'
  }
}
